import { AxiosInstance } from 'axios'

interface ICannyTokensResponse {
  board_token: string;
  sso_token: string;
}

export function cannyApiFactory(api: AxiosInstance) {
  const methods = {
    getTokens() {
      return api.get<ICannyTokensResponse>('/api/v1/canny/access-tokens')
    }
  }
  return methods
}
